import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="google-places"
export default class extends Controller {
  static targets = [
    'locationInput',
    'timezoneInput',
    'latitudeInput',
    'longitudeInput',
    'countryInput',
    'mapCanvas',
    'cityInput',
    'postalCodeInput',
    'countrySelect'
  ]

  static values = {
    existingLatitude: Number,
    existingLongitude: Number
  }

  connect () {
    this.advancedOptionsToggle = false

    google.maps.importLibrary('maps').then(({ Map }) => {
      google.maps.importLibrary('places').then(({ Autocomplete }) => {
        this.autocomplete = new Autocomplete(this.locationInputTarget)

        const defaultMapOptions = {
          zoom: 2,
          center: { lat: 50.7963372, lng: -1.0659786 },
          gestureHandling: 'none'
        }

        this.map = new Map(this.mapCanvasTarget, defaultMapOptions)

        if (
          this.existingLatitudeValue !== 0 &&
          this.existingLongitudeValue !== 0
        ) {
          this.updateMap(
            this.existingLatitudeValue,
            this.existingLongitudeValue
          )
        }

        this.autocomplete.addListener('place_changed', async () => {
          const place = this.autocomplete.getPlace()
          if (!place.geometry || !place.geometry.location) return

          const latitude = place.geometry.location.lat()
          const longitude = place.geometry.location.lng()
          let country = ''

          if (place.address_components) {
            const countryComponent = place.address_components.find(component =>
              component.types.includes('country')
            )
            if (countryComponent) {
              country = countryComponent.long_name
            }
          }

          this.updateMap(latitude, longitude)
          this.updateShippingAddressFromPlace(place)

          const response = await fetch(
            `/api/timezones?latitude=${latitude}&longitude=${longitude}`
          )

          if (response.ok) {
            const json = await response.json()
            this.updateInterface(
              json.timezone,
              latitude,
              longitude,
              country
            )
          }
        })
      })
    })
  }

  updateInterface (timezone, latitude, longitude, country) {
    this.timezoneInputTarget.value = timezone
    this.latitudeInputTarget.value = latitude.toFixed(7)
    this.longitudeInputTarget.value = longitude.toFixed(7)

    if (this.hasCountryInputTarget) {
      this.countryInputTarget.value = country
    }
  }

  updateMap (latitude, longitude) {
    const position = new google.maps.LatLng(latitude, longitude)

    if (!this.marker) {
      this.marker = new google.maps.Marker({
        position,
        map: this.map
      })
    } else {
      this.marker.setPosition(position)
    }

    this.map.moveCamera({
      center: position,
      zoom: 13
    })
  }

  toggleAdvancedOptions () {
    const enabled = this.advancedOptionsToggle

    this.latitudeInputTarget.required = !enabled
    this.longitudeInputTarget.required = !enabled

    this.latitudeInputTarget.disabled = enabled
    this.longitudeInputTarget.disabled = enabled

    this.advancedOptionsToggle = !enabled
  }

  updateShippingAddressFromPlace (place) {
    if(!this.hasPostalCodeInputTarget) return

    const components = place.address_components || []
    const find = (type) => components.find(c => (c.types || []).includes(type))

    const city =
      (find('locality') && find('locality').long_name) ||
      (find('postal_town') && find('postal_town').long_name) ||
      (find('administrative_area_level_2') && find('administrative_area_level_2').long_name) ||
      ''

    const postalCode = (find('postal_code') && find('postal_code').long_name) || ''
    const countryCode = (find('country') && find('country').short_name) || ''

    if (this.hasCityInputTarget && city) this.cityInputTarget.value = city
    if (this.hasPostalCodeInputTarget && postalCode) this.postalCodeInputTarget.value = postalCode
    if (this.hasCountrySelectTarget && countryCode) this.countrySelectTarget.value = countryCode
  }

}
